"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/28
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCompletedFile = exports.getCompletedFile = exports.clearCompletedFiles = void 0;
// Store completed file blobs for download/use
const completedFiles = new Map();
const setCompletedFile = (fileKey, file) => {
    const hasExistingKey = completedFiles.has(fileKey);
    if (hasExistingKey) {
        // If key already exists, delete it first to move it to the end (latest position)
        completedFiles.delete(fileKey);
    }
    completedFiles.set(fileKey, file);
};
exports.setCompletedFile = setCompletedFile;
const getCompletedFile = (fileKey) => {
    if (fileKey) {
        const completedFile = completedFiles.get(fileKey);
        return completedFile ? Object.assign(Object.assign({}, completedFile), { fileKey }) : undefined;
    }
    // If no fileKey provided, return the latest file
    return getLatestCompletedFile();
};
exports.getCompletedFile = getCompletedFile;
const getLatestCompletedFile = () => {
    const hasNoCompletedFiles = completedFiles.size === 0;
    if (hasNoCompletedFiles) {
        return undefined;
    }
    // Get the last entry from the Map (most recently added/updated)
    const entries = Array.from(completedFiles.entries());
    const [latestKey, completedFile] = entries[entries.length - 1];
    return Object.assign(Object.assign({}, completedFile), { fileKey: latestKey });
};
const clearCompletedFiles = () => {
    completedFiles.clear();
};
exports.clearCompletedFiles = clearCompletedFiles;
//# sourceMappingURL=completed.js.map